import React, { PropTypes, Component } from 'react';
import { NitroText, NitroButton, NitroHeading } from 'nitro-components';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import styled from 'styled-components';

import { media } from 'style-utils';

import CustomRButtons from './CustomRButtons';

import {EMAIL_WEEKLY_HEADING} from '../content';

const MainContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: baseline;
  background: #F7F7F7;
  padding: 6px 24px;

  ${media.mobile`
    justify-content: center;
  `}
`;

const RadioButtonWeekContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  ${media.mobile`
    justify-content: center;
  `}

  input[type="radio"] {
    display:none;
  }

  > section {
    margin: 5px;

    ${media.mobile`
       margin: 8px;
    `}
  }

  label {
    display:inline-block;
    background-color: ${props => props.theme.color.white};
    padding: 6px 10px;
    border: 1px solid ${props => props.theme.color.border};
    border-radius: 60px;
    height: 30px;
    min-width: 60px;
    text-align: center;
    font-size: ${props => props.theme.size[4] + 'px'};
    color: ${props => props.theme.color.base2};
  }

  label:hover {
    background-color: ${props => props.theme.color.base2};
    color: ${props => props.theme.color.white};
    cursor: pointer;
  }

  input[type="radio"]:checked + label {
    background-color:${props => props.theme.color.base2};
    border-color: ${props => props.theme.color.base2};
    color: ${props => props.theme.color.white};
  }
`;

const weekdays = [
  { Key: 1, Value: 'Mon' },
  { Key: 2, Value: 'Tue' },
  { Key: 3, Value: 'Wed' },
  { Key: 4, Value: 'Thu' },
  { Key: 5, Value: 'Fri' },
  { Key: 6, Value: 'Sat' },
  { Key: 0, Value: 'Sun' }
];

class WeeklySettings extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { data } = this.props;
    const id = data.ContentKey;
    const emailNotifData = data.Email;
    const selectedValue = emailNotifData
      ? emailNotifData.EmailParameter
      : null;

    return (
      <MainContainer>
        <NitroHeading
          label={EMAIL_WEEKLY_HEADING}
          size="4"
          header
          variant="base2"
          noMargin
        />
        {/**Reuse CustoRButtons - to be checked*/}
        <RadioButtonWeekContainer>
          {weekdays.map((item, index) => {
            const key = `${id}_${item.Key}_${item.Key}`;
            const inputAttrs = {
              type: 'radio',
              id: key,
              name: key,
              value: item.Key,
              onClick: () => {
                this.props.action(id, item.Key);
              },
              onChange: () => {}
            };

            if (typeof selectedValue !== 'undefined') {
              inputAttrs.checked = item.Key === selectedValue;
            }

            return (
              <section key={key}>
                <input {...inputAttrs} />
                <label htmlFor={key}>
                  {item.Value}
                </label>
              </section>
            );
          })}
        </RadioButtonWeekContainer>

      </MainContainer>
    );
  }
}

WeeklySettings.propTypes = {
  action: PropTypes.func,
  data: PropTypes.object
};

export default WeeklySettings;



// WEBPACK FOOTER //
// ./src/features/notification/notification-settings/components/WeeklySettings.js